import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { GalleryUsageResponse } from '../../Models/Models';
import DiscardButton from '../Buttons/DiscardButton';
import DeleteButton from '../Buttons/DeleteButton';
import { Link } from 'react-router-dom';
import CustomTooltip from '../Tooltips/CustomTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faTrash } from '@fortawesome/free-solid-svg-icons';
import { SiteContext, ToastContext } from '../../Contexts';
import { GalleryService } from '../../Services/GalleryService';

interface Props {
    show: boolean;
    onHide: () => void;
    onSubmit: () => void;
    idToDelete: number;
}

const GalleryDeleteModal: React.FC<Props> = ({ show, onHide, onSubmit, idToDelete }) => {
    const { checkGalleryUsage } = GalleryService();
    const [usageData, setUsageData] = useState<GalleryUsageResponse | null>(null);
    const { setToast }: any = useContext(ToastContext);
    const { currentSite }: any = useContext(SiteContext);

    const load = async (initCall: boolean) => {
        const data = await checkGalleryUsage(idToDelete);
        setUsageData(data);
        if (!initCall) setToast({ message: 'Použitia galérie úspešne obnovené' });
    };

    useEffect(() => {
        if (idToDelete === 0) return;
        void load(true);
    }, [idToDelete]);

    const usageCount = usageData ? usageData.posts.length : 0;

    return (
        <Modal show={show} onHide={onHide} centered>
            <div className="st-delete-modal-stripe" />
            <Modal.Header className="st-delete-modal-header">
                <div className="st-delete-modal-header-inner">
                    <div className="st-delete-modal-icon-badge">
                        <FontAwesomeIcon icon={faTrash} className="st-delete-modal-icon" />
                    </div>
                    <span className="st-delete-modal-title">Zmazať galériu?</span>
                </div>
            </Modal.Header>

            <Modal.Body className="st-delete-modal-body">
                {!usageData ? (
                    <p className="text-secondary mb-0">Načítavam...</p>
                ) : usageCount > 0 ? (
                    <>
                        <p className="st-delete-modal-text-gap">
                            Naozaj chcete zmazať túto galériu? Je použitá na:
                        </p>
                        <ul className="st-delete-modal-usage-list st-delete-modal-usage-list--tight">
                            {usageData.posts.map(post => (
                                <li key={post.id}>
                                    <Link target="_blank" to={`/post/edit/${post.id}?websiteId=${currentSite.id}`}
                                        className="st-link-blue">
                                        {post.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : (
                    <p className="st-delete-modal-description">
                        Naozaj chcete zmazať túto galériu? Túto operáciu nie je možné vrátiť naspäť.
                    </p>
                )}
            </Modal.Body>

            <Modal.Footer className="st-delete-modal-footer">
                {usageCount > 0 && (
                    <CustomTooltip placement="bottom" message="Obnoviť použitia galérie">
                        <Button variant="light" className="st-btn-refresh" onClick={() => load(false)}>
                            <FontAwesomeIcon icon={faRefresh} />
                        </Button>
                    </CustomTooltip>
                )}
                <DiscardButton onClick={onHide} />
                <DeleteButton onClick={onSubmit} />
            </Modal.Footer>
        </Modal>
    );
};

export default GalleryDeleteModal;
